export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-en-568e6e7d9a6bbb0b0ae66e56139c0374.png";